import { keys } from 'underscore'
import { isApp, reactNativeLog } from '@/utils/ReactNative'
import * as Sentry from '@sentry/vue'
import store from '@/store'
import { _ } from 'vue-underscore'
import moment from 'moment'

export const capitalize = field => {
  return field.charAt(0).toUpperCase() + field.slice(1)
}

export const parseText = text => {
  let parsed = secParseJSON(text) || ''
  parsed = unescape(parsed)
  return parsed
}

export const secParseJSON = text => {
  let parsed
  try {
    parsed = JSON.parse(text)
  } catch (error) {
    parsed = null
    Sentry.captureException(error)
  }
  return parsed
}

export const removeByKey = (myObj, deleteKey) => {
  return keys(myObj)
    .filter(key => key !== deleteKey)
    .reduce((result, current) => {
      result[current] = myObj[current]
      return result
    }, {})
}

export const secureShareLink = (url, createdData, postId, owner) => {
  const dateCreated = createdData.seconds
  const parsePostIDAndCreateDate = btoa(`${dateCreated}:${postId}:`)
  const result = `${url}/${parsePostIDAndCreateDate}`
  return result
}

const _titleizeWord = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const titleize = sentence => {
  if (!sentence.split) {
    return _titleizeWord(sentence)
  }
  const result = []
  sentence.split('_').forEach(w => {
    result.push(_titleizeWord(w))
  })
  return result.join('')
}

export const SortByDateField = (arrayOfObjects, field) => {
  const orderByDate = arrayOfObjects.sort(
    (a, b) => b[field].seconds - a[field].seconds
  )
  return orderByDate
}
export const comparePublishedAt = (a, b) => {
  if (a.published_at < b.published_at) {
    return -1
  }
  if (a.published_at > b.published_at) {
    return 1
  }
  return 0
}

export const getValidStyle = style => {
  const colors = [
    'primary',
    'secondary',
    'success',
    'teal',
    'danger',
    'warning',
    'info',
    'light',
    'dark'
  ]
  return colors.includes(style) ? style : 'primary'
}

export const isMobile = () => {
  return !!navigator.userAgent.toLowerCase().match(/mobile/i)
}

export const browserLog = message => {
  isApp ? reactNativeLog(message) : console.log(message)
}

export const daysFrom = date => {
  const date1 = new Date(date)
  const date2 = new Date()
  const oneDay = 1000 * 60 * 60 * 24
  const diffInTime = date2.getTime() - (date1.getTime() || 0)
  const diffInDays = Math.round(diffInTime / oneDay)
  return diffInDays
}

export const forceSSL = initialUrl => {
  return store.getters.getForceSSL
    ? initialUrl.replace('http://', 'https://')
    : initialUrl
}

export const convertEmToPixels = pixels => {
  const em = store.getters.getFontSizeDeviceInfo
  return em * pixels
}
export const likeAtScoreStructure = fullScore => {
  const scoreString = fullScore.toString()
  const last4Scoredigits = scoreString.substring(
    scoreString.length - 4,
    scoreString.length
  )
  const formatDate = moment().format('YYMMDDHHmmss')
  const fullScoreStructure = `${formatDate}${last4Scoredigits}`
  return parseInt(fullScoreStructure)
}
export const sortedIndex = (list, fieldName, fieldValue) => {
  let low = 0
  let ele = null
  let high = list.length
  let mid = 0
  while (low < high) {
    mid = Math.floor((low + high) / 2)
    while (!list[mid] || !list[mid][fieldName]) {
      mid += 1
    }
    ele = list[mid]
    if (fieldValue > ele[fieldName]) high = mid
    else low = mid + 1
  }
  return low
}
export const getIndexForNewItem = (list, fieldName, fieldValue) => {
  // const index = _.findIndex(list, elem => elem && elem[fieldName] <= fieldValue)
  // return index > -1 ? index : list.length
  return sortedIndex(list, fieldName, fieldValue)
}

export const getIndexForItem = (list, fieldName, fieldValue) => {
  return _.findIndex(list, elem => elem && elem[fieldName] === fieldValue)
}

export const addListItem = (list, newItem, pos) => {
  if (pos > list.length) {
    list[pos] = newItem
    list = [...list]
  } else {
    list.splice(pos, 0, newItem)
  }
  return list
}

export const updateIndex = (list, from = 0, to = -1) => {
  to = to < 0 ? list.length : to
  to = to > list.length ? list.length : to
  for (let i = from; i < to; i++) {
    if (list[i]) {
      list[i].index = from
    }
  }
  return list
}



// WEBPACK FOOTER //
// ./src/helper/helper.js